export class StoredgeUnitSyncModel {
    public internalId: string;
    public storedgeId: string;
    public status: number;
}
